module.exports = __webpack_public_path__ + "static/media/projects.c31e1ba6.svg";